import {
  AfterViewInit,
  Component,
  EventEmitter,
  forwardRef,
  Inject,
  Injector,
  Input,
  OnDestroy,
  Optional,
  Output,
  ViewContainerRef,
} from '@angular/core';
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { PrTable } from '@app/components/pr-table/pr-table.component';
import * as _ from 'lodash';
import { takeWhile } from 'rxjs';
import { PrFormAbstract } from '../pr-form.abstract';
import { ListOptionVariant } from '@app/models/asset';
interface ExtendedInjector extends Injector {
  view: { component: any };
}

@Component({
    selector: 'pr-table-form',
    templateUrl: './pr-table-form.component.html',
    styleUrls: ['./pr-table-form.component.scss'],
    standalone: false
})
export class PrTableFormComponent implements AfterViewInit, OnDestroy {
  alive = true;
  formGroup: UntypedFormGroup;
  @Input() derrors: boolean = false;
  @Input() set columnsDefinition(value) {
    if (!value) return;
    this._columnsDefinition = value;
    this.initTable();
  }
  get columnsDefinition() {
    return this._columnsDefinition;
  }
  _columnsDefinition;
  @Input() addListOptions;
  @Input() formatTable;
  @Input() createModelDefinition: (options) => any;
  @Input() swiperMinWidth: number = 1;
  @Input() addButtonLabel: string = 'Ajouter';
  @Input() hasAddButton: boolean = true;
  @Input() hasConfirmButton: boolean = true;
  @Input() variant: ListOptionVariant = 'DEFAULT';
  @Output() deleteItem: EventEmitter<any> = new EventEmitter();
  @Output() optionSelected: EventEmitter<any> = new EventEmitter();
  @Output() onSelectClick: EventEmitter<any> = new EventEmitter();
  @Output() noData: EventEmitter<any> = new EventEmitter();
  _tableData;

  constructor(
    private controlContainer: ControlContainer,
    private formBuilder: UntypedFormBuilder,
  ) {}

  get control(): UntypedFormArray {
    return this.controlContainer.control as UntypedFormArray;
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.initTable(), 0);

    this.control.valueChanges
      .pipe(takeWhile(() => this.alive))
      .subscribe(() => this.initTable());
  }

  initTable(data?) {
    this._tableData = new PrTable(
      data || this.formatTable ? this.formatTable(this.control.value) : [],
      this.columnsDefinition,
    );
    if (this._tableData.data.length === 0) {
      this.noData.emit(true);
    } else {
      this.noData.emit(false);
    }
  }

  onOptionSelected(option) {
    let newControl = this.formBuilder.group(this.createModelDefinition(option));
    this.control.push(newControl);
    this.optionSelected.emit(option);
    this.initTable();
  }

  _deleteItem(item) {
    this.control.removeAt(item.index);
    this.deleteItem.emit(item);
    this.initTable();
  }

  get formatedListOption() {
    return this.addListOptions
      ? _.filter(
          this.addListOptions,
          option => !_.map(this.control.value, 'name').includes(option.name),
        )
      : [];
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
